export enum EnumPickupFlag {
  CRRNFD = 'CRRNFD',
  DOX = 'DOX',
  CRROTW = 'CRROTW',
  DOLOTW = 'DOLOTW',
  CRRPIC = 'CRRPIC',
  CRRDON = 'CRRDON',
}
